<template>
  <div class="mainNavigation">
    <div class="mainNavigation_ribbon">
      <div class="mainNavigation_ribbon_item home" style="padding: 0px 3px 3px 3px;">
        <a :href="typeof iprUrl !== 'undefined' ? iprUrl + '/default.asp' : '/'" class="mainNavigation_ribbon_item_link" style="margin-top: -5px;">Home</a>
      </div>
      <NavBarLocation/>
      <div class="mainNavigation_ribbon_item region bud">
        <span class="mainNavigation_ribbon_item_outsideButton"></span>
        <span class="mainNavigation_ribbon_item_insideButton"></span>
        <a class="mainNavigation_ribbon_item_link" title="click here to list all regions for organisation" :href="iprUrl + '/pages/regions.aspx?id=10'">Regions</a>
        <a class="mainNavigation_ribbon_item_icon" title="click here to list all regions for organisation" :href="iprUrl + '/pages/regions.aspx?id=10'"></a>
      </div>
    </div>
  </div>
</template>

<script>
import appConfig from '@/config'
import NavBarLocation from "@/components/layout/standard/NavBarLocation"

export default {
    name: "NavBar",
    components: {NavBarLocation},
    data(){
      return {
        iprUrl: appConfig.IPR_BASE_URL,
      }
    }
  }
</script>
